import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { GtmContainersResponse } from 'Features/domainsManagement/components/GetTagModal/components/Instructions/GoogleTagManager/types/GtmTypes'

type QueryFnType = typeof getGtmAccountContainers

export const useGetGtmAccountContainers = (googleToken: string, gtmAccountId: string) => {
  const { accountId } = useUserStore.getState()

  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['gtmAccountContainers', accountId, gtmAccountId],
    queryFn: () => getGtmAccountContainers(accountId || 0, googleToken, gtmAccountId),
    enabled: !!accountId && googleToken.length > 0 && gtmAccountId.length > 0,
  })

  const data = query.data && query.data instanceof Error ? undefined : query?.data?.data
  return { ...query, data }
}

const getGtmAccountContainers = async (
  accountId: number,
  googleToken: string,
  gtmAccountId: string
): Promise<{ data: GtmContainersResponse } | Error> => {
  return await request({
    url: `accounts/${accountId}/google-tag-manager/get-containers`,
    method: 'POST',
    data: {
      token: googleToken,
      gtmAccountId,
    },
    hideErrorToaster: true,
  })
}
